import { XMarkIcon } from '@heroicons/react/16/solid';
import { Emoji } from 'emoji-picker-react';
import { useState } from 'react';
import { Button, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { LLog, LOG_COMPONENTS, LOG_OPERATIONS } from 'src/lib/logging';
import { useAnalytics } from 'src/hooks/analytics/useAnalytics.hook';
import { IntegrationsService } from '../../../../../providers/IntegrationsProvider/Integrations.service.ts';
import { useModalsContext } from '../../../../../providers/ModalsProvider/Modals.context.ts';
import { eAlertType } from '../../../../../providers/ToastProvider/Toast.enum.ts';
import { useToastContext } from '../../../../../providers/ToastProvider/Toast.hook.ts';
import { useWorkspaceContext } from '../../../../../providers/WorkspaceProvider/Workspace.context.ts';
import './ForceDisconnectionModal.styles.scss';

export default function ForceDisconnectionModal() {
  const { setForceDisconnectionModalIsOpen, forceDisconnectionModalIsOpen } =
    useModalsContext();
  const [isLoading, setIsLoading] = useState(false);
  const { currentWorkspaceId } = useWorkspaceContext();
  const { addAlert } = useToastContext();
  const { t } = useTranslation('sidebar/sidebarComponent');
  const { trackEvent } = useAnalytics();

  const handleDisconnectModal = async () => {
    setIsLoading(true);
    if (currentWorkspaceId === undefined || currentWorkspaceId === null) {
      return;
    }

    try {
      await IntegrationsService.closeChatDaddySession(currentWorkspaceId);
      setForceDisconnectionModalIsOpen(false);

      trackEvent('front.dashboard.integrations.whatsapp_disconnect.success', {
        displayName: 'Desconexión Whatsapp',
        description:
          'Cuantas usuarias realizaron una desconexión forzada exitosa de whatsapp',
        accountType: 'whatsapp',
        accountStatus: 'disconnected',
      });
    } catch (err) {
      LLog.error(
        {
          component: LOG_COMPONENTS.UI,
          method: 'ForceDisconnectionModal.component',
          operation: LOG_OPERATIONS.ERROR,
        },
        'Error al desconectar sesión',
        err as unknown as Error,
      );
      addAlert({
        type: eAlertType.ERROR,
        message: (err as Error).message || 'Ocurrió un error al desconectarte',
      });
    }
    setIsLoading(false);
  };

  return (
    <Modal.Legacy
      open={forceDisconnectionModalIsOpen}
      onClickBackdrop={() => {
        setForceDisconnectionModalIsOpen(false);
      }}
      className="DisconnectionModal"
    >
      <Modal.Header>
        <XMarkIcon
          onClick={() => {
            setForceDisconnectionModalIsOpen(false);
          }}
          className="ForceDisconnectModal__Icon"
        />
      </Modal.Header>
      <Modal.Body>
        <div className="ForceDisconnectModal__Container">
          <Emoji unified="26a0-fe0f" size={50} />
          <h1 className="ForceDisconnectModal__Container__Title">
            {t('page.modals.forceDisconnection.title')}
          </h1>
          <h2 className="ForceDisconnectModal__Container__Subtitle">
            {t('page.modals.forceDisconnection.subtitle')}
          </h2>
        </div>
        <div className="ForceDisconnectModal__Buttons">
          <Button
            variant="outline"
            color="primary"
            onClick={() => {
              setForceDisconnectionModalIsOpen(false);
            }}
          >
            {t('page.modals.forceDisconnection.cancelButton')}
          </Button>
          <Button
            loading={isLoading}
            color="error"
            onClick={handleDisconnectModal}
          >
            {t('page.modals.forceDisconnection.disconnectButton')}
          </Button>
        </div>
      </Modal.Body>
    </Modal.Legacy>
  );
}
